import React, { FC, InputHTMLAttributes } from "react";

import { classNames } from "~/pages/Editor/classNames";

import s from "./Input.less";

interface InputProps extends InputHTMLAttributes<HTMLButtonElement> {
  className?: string;
  inputAdditionalClass?: string;
  name: string;
  label?: string;
}
const Input: FC<InputProps> = (props) => {
  const { name, label, className, inputAdditionalClass, ...otherProps } = props;

  return (
    <div className={classNames(s.wrapper, {}, [className])}>
      {label && <label className={s.label}>{label}</label>}
      <input
        className={classNames(s.input, {}, [inputAdditionalClass])}
        name={name}
        {...otherProps}
      />
    </div>
  );
};

export default Input;
